import {useEffect, useRef} from "react"
import {useTranslation} from "react-i18next"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import StProjectsModalForm from "../../forms/st-projects/StProjectsModalForm"
import EcpProjectsModalForm from "../../forms/ecp-projects/EcpProjectsModalForm"
import closeIcon from "../../assets/icon/close.svg"
import useClickOutside from "../../tools/useClickOutside"
import ScrollingMod from "../../tools/ScrollingMod"

export default function ProjectsModal({type, mutateStProjects, mutateEcpProjects}) {
    const {t} = useTranslation()
    const {setStProjectsAction} = useStProjectsContext()
    const {setEcpProjectsAction} = useEcpProjectsContext()
    const projectModalModalRef = useRef(null)

    const closeModal = () => {
        type === "st" ? setStProjectsAction({type: "ST_PROJECTS_IS_MODAL", payload: {isModal: false}}) : setEcpProjectsAction({type: "ECP_PROJECTS_IS_MODAL", payload: {isModal: false}})
        ScrollingMod(false)
    }

    useClickOutside(projectModalModalRef, () => {
        closeModal()
    })

    useEffect(() => {
        window.scrollTo(0, 0)
        ScrollingMod(true)
    }, [])

    return (
        <>
        <div ref={projectModalModalRef} className="PROJECTS-MODAL">
            <>
            <h2>{t("New project")}</h2>
            <img className="close" src={closeIcon} alt="" onClick={closeModal}/>
            {type === "st" ?
                <StProjectsModalForm mutateStProjects={mutateStProjects} closeModal={closeModal}/>
                :
                <EcpProjectsModalForm mutateEcpProjects={mutateEcpProjects} closeModal={closeModal}/>
            }
            </>
        </div>
        </>
    )
}